import { render } from "./landing-page.vue?vue&type=template&id=d3a84090&scoped=true&ts=true"
import script from "./landing-page.ts?vue&type=script&lang=ts&external"
export * from "./landing-page.ts?vue&type=script&lang=ts&external"

import "./landing-page.less?vue&type=style&index=0&id=d3a84090&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3a84090"]])

export default __exports__